import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSettings } from "@/hooks/useSettings";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import LoginDialog from "@/components/site/LoginDialog";

const TITLES = { "/aktualnosci": "Aktualności", "/pobierz": "Pobierz grę", "/ranking": "Ranking", "/rejestracja": "Rejestracja", "/panel": "Panel gracza" };

export default function SiteLayout() {
  const settings = useSettings({ server_name: "Koselig2 - AI-Driven Paradise" });
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => { document.title = TITLES[pathname] ? `${TITLES[pathname]} - ${settings.server_name}` : settings.server_name; }, [pathname, settings.server_name]);

  return (
    <div className="bg-[#05060f] text-slate-300 min-h-screen overflow-x-hidden flex flex-col" data-testid="website">
      <SiteNav name={settings.server_name} />
      <main className="flex-1"><Outlet context={{ settings }} /></main>
      <SiteFooter settings={settings} />
      <LoginDialog />
    </div>
  );
}
